import React from 'react';
import { Flex, Box } from 'rebass/styled-components';
import { RequestIntro } from 'components/organisms/contactActionPanel/requestIntro';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

export const RequestBulkIntro = ({ selectedContacts, listInfo, params, setSelectedContacts, contacts }) => {
  if (!listInfo.introRequestsEnabled) {
    return null;
  }

  return (
    <Flex sx={{ alignItems: 'center' }}>
      <Box
        sx={{
          width: '1px',
          height: '24px',
          backgroundColor: 'border.subtle',
          mr: '16px',
          display: ['none', 'none', 'block'],
        }}
      />
      <Flex sx={{ gap: '8px', alignItems: 'center', pl: ['8px', '8px', '0px'] }}>
        <RequestIntro
          slug={params.slug}
          clearSelectedContacts={() => setSelectedContacts(new Set())}
          isSingleContact={false}
          selectedContacts={contacts.filter((contact) => selectedContacts.has(contact.id))}
          buttonProps={{
            disabled: selectedContacts.size === 0,
            variant: 'primary',
            width: 'fit-content',
            size: 'small',
            minWidth: '150px',
          }}
          list={listInfo}
        >
          {selectedContacts.size === 0
            ? 'Request intros'
            : `Request ${selectedContacts.size} ${pluralize('intro', selectedContacts.size)}`}
        </RequestIntro>
        {selectedContacts.size === 0 && (
          <Box sx={{ fontSize: '12px', color: 'text.subtle', fontStyle: 'italic' }}>Select contacts to get started</Box>
        )}
      </Flex>
    </Flex>
  );
};

RequestBulkIntro.propTypes = {
  selectedContacts: PropTypes.instanceOf(Set).isRequired,
  listInfo: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  setSelectedContacts: PropTypes.func.isRequired,
  contacts: PropTypes.array.isRequired,
};
